require('../../modules/es.array.reduce-right');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'reduceRight');
